@if (visible()) {
  <div
    class="modal-backdrop"
    [class.closing]="isClosing()"
    (click)="onBackdropClick()"
    (keydown)="onBackdropKeydown($event)"
    tabindex="0"
  >
    <div
      class="modal-content"
      [ngClass]="{
        'modal-size-small': size() === 'small',
        'modal-size-large': size() === 'large',
        'modal-size-fullscreen': size() === 'fullscreen',
        closing: isClosing(),
      }"
      (click)="$event.stopPropagation()"
      (keydown)="onBackdropKeydown($event)"
      tabindex="0"
    >
      <div class="mobile-swipe-indicator"></div>
      <div class="modal-header">
        <h3>{{ title() }}</h3>
        <lib-icon-button
          icon="x"
          (clicked)="close()"
          (keydown.enter)="close()"
        ></lib-icon-button>
      </div>

      @if (description()) {
        <p class="modal-description">
          {{ description() }}
        </p>
      }

      <ng-content></ng-content>
    </div>
  </div>
}
